<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0 7.49883C0 3.63476 3.58097 0.5 8 0.5C12.4184 0.5 16 3.63476 16 7.49883C16 11.366 12.4184 14.4977 8 14.4977C7.48692 14.4977 6.98945 14.4514 6.50324 14.3733L3.00039 16.5V12.9578C1.17178 11.676 0 9.70803 0 7.49883ZM3.93782 11.8105C2.45207 10.8011 1.5 9.25132 1.5 7.51158C1.5 4.46862 4.40954 2 8 2C11.59 2 14.5 4.46862 14.5 7.51158C14.5 10.557 11.59 13.0232 8 13.0232C7.58312 13.0232 7.17893 12.9867 6.78388 12.9252L6.42563 12.8478L4.31046 14.1878V12.067L3.93782 11.8105Z"
                :fill="color" 
            />
            <mask id="mask0_5813_8075" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="16"
                height="17">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M0 7.49883C0 3.63476 3.58097 0.5 8 0.5C12.4184 0.5 16 3.63476 16 7.49883C16 11.366 12.4184 14.4977 8 14.4977C7.48692 14.4977 6.98945 14.4514 6.50324 14.3733L3.00039 16.5V12.9578C1.17178 11.676 0 9.70803 0 7.49883ZM3.93782 11.8105C2.45207 10.8011 1.5 9.25132 1.5 7.51158C1.5 4.46862 4.40954 2 8 2C11.59 2 14.5 4.46862 14.5 7.51158C14.5 10.557 11.59 13.0232 8 13.0232C7.58312 13.0232 7.17893 12.9867 6.78388 12.9252L6.42563 12.8478L4.31046 14.1878V12.067L3.93782 11.8105Z"
                    fill="white" />
            </mask>
            <g mask="url(#mask0_5813_8075)">
            </g>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgComment',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>